import type { SetupScreen, SetupStepNavigator } from './setup-screen'

/** The visual style screens, in order. The index of a screen is its place in setup. */
export const VISUAL_STYLE_SCREENS = [
  { id: 'choice', transient: false },
  { id: 'templates', transient: false },
  { id: 'template', transient: false },
  { id: 'own', transient: false },
] as const satisfies readonly SetupScreen[]

/** One visual style screen. */
export type VisualStyleScreen = (typeof VISUAL_STYLE_SCREENS)[number]['id']

export type VisualStyleMove =
  /** "I have my own designs", or the own designs tile of the templates. */
  | 'pick-own'
  /** "Show me templates". */
  | 'pick-templates'
  /** A template opened from the grid. */
  | 'open-template'
  /** Back on the own designs. */
  | 'back-to-choice'

/** What the saved data holds, reduced to what the step opens on. */
export interface VisualStyleResumeState {
  /** True when the step is confirmed. */
  readonly confirmed: boolean
  /** True when the saved style names own designs. */
  readonly ownDesigns: boolean
}

/** The screen the step opens on: a confirmed step opens on its saved pick. */
export function resumeVisualStyleScreen(state: VisualStyleResumeState): VisualStyleScreen {
  if (!state.confirmed) return 'choice'
  return state.ownDesigns ? 'own' : 'template'
}

/** The screen a move leads to. A move that does not apply to the screen on show keeps it. */
export function moveVisualStyle(from: VisualStyleScreen, move: VisualStyleMove): VisualStyleScreen {
  switch (move) {
    case 'pick-own':
      return from === 'choice' || from === 'templates' ? 'own' : from
    case 'pick-templates':
      return from === 'choice' ? 'templates' : from
    case 'open-template':
      return from === 'templates' ? 'template' : from
    case 'back-to-choice':
      return from === 'own' ? 'choice' : from
  }
}

export const VISUAL_STYLE_NAVIGATOR: SetupStepNavigator<VisualStyleScreen, VisualStyleMove> = {
  screens: VISUAL_STYLE_SCREENS,
  move: moveVisualStyle,
}
